import classNames from 'classnames';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';
import { generateFullName } from 'utils/badgeHelpers';
import useUser from 'utils/useUser';
import TrashDeleteIcon from 'components/atoms/icons/trashIcon';
import useAlert from 'infrastructure/hooks/utils/use-alert';

import s from './styles.module.scss';

import type { IActivityComments } from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { TDeleteCommentFn } from 'infrastructure/hooks/rpm';

interface MessageItemProps {
  isMockComment: boolean;
  comment: IActivityComments;
  isErroneousComment?: boolean;
  deleteComment: TDeleteCommentFn;
}

const MessageItem: FC<MessageItemProps> = ({
  isMockComment,
  comment,
  isErroneousComment,
  deleteComment,
}) => {
  const { t } = useTranslation();
  const { userType, isAdmin } = useUser();
  const { Alert, showAlert } = useAlert();

  const handleDelete = async () => {
    const message = `${t('labels.commentDeleteConfirm')} ${t(
      'labels.commentDeleteConfirmInteractiveTime',
    )}`;
    const alertAnswer = await showAlert({
      title: t('labels.commentDeleteTitle'),
      messageTitle: message,
      successBtnLabel: t('controls.yes'),
      rejectBtnLabel: t('controls.no'),
    });

    if (alertAnswer) {
      await deleteComment({
        guid: comment.guid,
        userType,
      });
    }
  };
  return (
    <li
      data-cy="comment"
      className={classNames(s['comment-item'], {
        [s.mock]: isMockComment,
      })}
      key={comment.guid}
      data-new-action={comment?.newAction}
    >
      {isAdmin && (
        <div className={s['top-right-actions']}>
          <button
            className={s['delete-button']}
            onClick={handleDelete}
            aria-label="Delete comment"
          >
            <TrashDeleteIcon />
          </button>
        </div>
      )}
      {Alert}
      <p data-cy="comment-text" className={s['comment-message']}>
        {isErroneousComment && (
          <span style={{ display: 'block', lineHeight: 1 }}>
            <b>Reason:</b>
          </span>
        )}
        {comment.message}
      </p>
      <div data-cy="signed-by" className={s['comment-signed-by']}>
        <p>
          <span>{t('labels.electronicallySignedBy')}: </span>
          <span>
            {generateFullName(
              comment.createdByTitle,
              comment.createdByFirstName,
              '',
              comment.createdByLastName,
              comment.createdByProfessionType,
            )}
          </span>
        </p>
        <span>
          {DateFormatter({
            date: comment.createdAt,
            format: DateFormats['MM-dd-yyyy | h:mm a'],
          })}
        </span>
      </div>
    </li>
  );
};
export default MessageItem;
